export default __webpack_public_path__ + "static/media/11.f01bd44b.jpg";